import { Flex, Box, LinkV2, styled } from '@withjoy/joykit';

export const BANNER_HEIGHT = 64;

export const BannerWrapper = styled(Flex)`
  position: absolute;
  width: 100%;
  height: ${BANNER_HEIGHT}px;
  top: -${BANNER_HEIGHT}px;
  border-top: 0px;
  border-bottom: 1px solid ${props => props.theme.colors.mono3};
  animation: slideDown 1s ease-in-out 3s forwards;
  @keyframes slideDown {
    from {
      top: -${BANNER_HEIGHT}px;
    }
    to {
      top: 0px;
    }
  }
`;

export const StyledLink = styled(LinkV2)`
  &:visited {
    color: #5f269b;
  }
  &:hover {
    color: #7139bf;
  }
  &:active {
    color: #502080;
  }
`;

export const StyledBox = styled(Box)`
  display: inline-flex;
`;
